import React from "react";

import "./styles.scss";

import { Container, Row, Col } from "reactstrap";
import IconFMI from "../Icons/IconFMI";
import IconInstagram from "../Icons/IconInstagram";
import IconTwitter from "../Icons/IconTwitter";
import IconFacebook from "../Icons/IconFacebook";
import IconLinkedin from "../Icons/IconLinkedin";
import IconWhatsapp from "../Icons/IconWhatsapp";

const Footer = () => (
    <footer>
        <Container fluid tag="section" className="py-5">
            <div id="wpp-float">
                <a href="https://web.whatsapp.com/send?phone=34633332684&text=" target="_blank" rel="noreferrer" className="me-3">
                    <IconWhatsapp width={40} height={40} fill="#fff" />
                </a>
            </div>
            <Container>
                <Row tag="section">
                    <Col tag="article" md="6" lg="4" className="info text-center text-md-start">
                        <IconFMI width={60} height={60} />
                        <a href="tel:+34633332684" target="_blank" rel="noreferrer">+34 633 33 2684</a>
                        <a href="mailto:info@thefmimadrid.com" target="_blank" rel="noreferrer">
                            <strong>info@thefmimadrid.com</strong>
                        </a>
                        <p className="mb-0">Plaza del Callao, 1, Madrid, 28013, Madrid,<br/> Comunidad de Madrid, España.</p>
                    </Col>
                    <Col tag="article" md="6" lg="4" className="links text-center text-md-end text-lg-center py-3 py-md-0 my-3 my-md-0">
                        <a href="/"><em>TheFMI</em></a>
                        <a href="/quienes-somos">QUIENES SOMOS</a>
                        <a href="/contacto">FORMULARIO DE INSCRIPCIÓN</a>
                    </Col>
                    <Col tag="article" lg="4" className="contacts text-center text-lg-end">
                        <p>Contactanos</p>
                        <a href="http://instagram.com/thefmimadrid" target="_blank" rel="noreferrer">
                            <IconInstagram width={40} height={40} fill="#000" />
                        </a>
                        <a href="https://twitter.com/fmimadrid" target="_blank" rel="noreferrer" className="ms-3">
                            <IconTwitter width={38} height={38} fill="#000" />
                        </a>
                        <a href="https://www.facebook.com/The-Football-Management-Institute-123205137373997" target="_blank" rel="noreferrer" className="ms-3">
                            <IconFacebook width={35} height={35} fill="#000" />
                        </a>
                        <a href="https://www.linkedin.com/company/92520377/admin/?feedType=following" target="_blank" rel="noreferrer" className="ms-3">
                            <IconLinkedin width={40} height={40} fill="#000" />
                        </a>
                        <a href="https://web.whatsapp.com/send?phone=34633332684&text=" target="_blank" rel="noreferrer" className="ms-3">
                            <IconWhatsapp width={40} height={40} fill="#000" />
                        </a>
                    </Col>
                </Row>
            </Container>
        </Container>
        <Container fluid tag="section" className="copy py-3">
            <Container>
                <Row tag="section">
                    <Col md="6" className="text-center text-md-start">
                        <p>&copy; {(new Date().getFullYear())} - <strong>The Football Management Institute</strong> - Madrid</p>
                    </Col>
                    <Col md="6" className="text-center text-md-end">
                        <p className="develop mb-0">
                            <small>
                                Diseñado por <a href="https://www.instagram.com/fuegodigitalagencia/" target="_blank" rel="noreferrer">Fuego Digital</a> y
                                Desarrollado por <a href="https://www.someonevision.com/" target="_blank" rel="noreferrer">Someone Vision</a>
                            </small>
                        </p>
                    </Col>
                </Row>
            </Container>
        </Container>
    </footer>
);

export default Footer;
